import type { AqsiTraceSaleItem, TraceSaleVm } from './types'

/**
 * Текст «Скопировать отчёт» по одной продаже — для передачи администратору или в поддержку. Только то, что есть в разборе:
 * идентификатор продажи, времена, участки, сеть кассира, настройки кассы. Имён, контактов покупателя, сумм по позициям,
 * кассира и ключей в нём нет — их нет и в самом разборе.
 */
export function buildTraceReport(vm: TraceSaleVm, listed: AqsiTraceSaleItem | undefined): string {
  const lines: string[] = ['Диагностика продажи AQSI', `Продажа: ${vm.saleId}`]
  if (listed !== undefined) {
    lines.push(`Начата: ${listed.startedAt}`)
    lines.push(`Итог: ${listed.outcome}`)
  }
  lines.push(`Всего: ${vm.totalText}`)
  if (vm.summaryText !== null) lines.push(vm.summaryText)

  if (vm.waterfall.length > 0) {
    lines.push('', 'Участки:')
    for (const row of vm.waterfall) lines.push(`- ${row.label}: ${row.durationText} (${row.shareText})`)
  }
  if (vm.points.length > 0) {
    lines.push('', 'Контрольные точки:')
    for (const point of vm.points) {
      const tail = [point.durationText !== '—' ? point.durationText : '', point.outcome].filter((part) => part !== '').join(', ')
      lines.push(`${point.offsetText} · ${point.sourceText} · ${point.stageText}${tail === '' ? '' : ` (${tail})`}`)
    }
  }
  if (vm.networkText !== null) lines.push('', vm.networkText)
  if (vm.settings.length > 0) {
    lines.push('', 'Настройки кассы:')
    for (const setting of vm.settings) {
      lines.push(`- ${setting.label}: ${setting.valueText}${setting.slowsNote === null ? '' : ` — ${setting.slowsNote}`}`)
    }
  }
  if (vm.detailCount > 0) lines.push('', `Событий подробного режима: ${vm.detailCount}`)
  return lines.join('\n')
}
